import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import { rgbToHsl } from "@amcharts/amcharts4/.internal/core/utils/Colors";

declare var ko: any;

export class config_promotion_template extends vnTemplate {

    protected resultInfos: resultsInfo_template;
    protected pagination: pagination_template;
    protected filter: filterSimple_template;


    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {

        return [];
    }

    protected getTemplateHtml(): string {
        return `
            <div class="list-header w-justify">
                <div class="w-left" style="flex-wrap: wrap;">
                    <div class="w-tabs">
                        <div class="radio-to-tab">
                            <input type="radio" id="active_yes" value="list" data-bind="checked: viewType"/>
                            <label class="radio-label" for="active_yes">Promotions</label>
                        </div>
                        <div class="radio-to-tab">
                            <input type="radio" id="active_no" value="config" data-bind="checked: viewType"/>
                            <label  class="radio-label" for="active_no">Website Config</label>
                        </div>
                    </div>
                    <button data-bind="event: {click: onClickAddPromotion}, visible: viewType() == 'list' " class="btn secondary icon i-add" type="button" style="margin-left: 0;">Add Promotion</button>
                    <button data-bind="event: {click: onClickAddConfig}, visible: viewType() == 'config' " class="btn secondary icon i-add" type="button">Add Promotion Config</button>
                </div>

                <div class="w-right"  data-bind="visible: viewType() == 'list' ">
                    ` + this.filter.getHtmlBuild() + `
                    ` + this.pagination.getHtmlBuild() + `
                </div>
            </div>

            <div class="w-list-results" id="list-results">
                <table class="list-results" data-bind="visible: viewType() == 'list' ">
                    ` + this.resultInfos.getHtmlBuild() + `
                        <thead>
                            <tr>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'id') }, css: { 'list-sort-desc': orderByAndDirection()=='id_DESC', 'list-sort-asc': orderByAndDirection()=='id_ASC' }">ID</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'name') }, css: { 'list-sort-desc': orderByAndDirection()=='name_DESC', 'list-sort-asc': orderByAndDirection()=='name_ASC' }">Name</span></th>
                                <th><span>GEO</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'isLoginUser') }, css: { 'list-sort-desc': orderByAndDirection()=='isLoginUser_DESC', 'list-sort-asc': orderByAndDirection()=='isLoginUser_ASC' }">Login User Condition</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'isPremiumUser') }, css: { 'list-sort-desc': orderByAndDirection()=='isPremiumUser_DESC', 'list-sort-asc': orderByAndDirection()=='isPremiumUser_ASC' }">Premium User Condition</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'isAdBlockUser') }, css: { 'list-sort-desc': orderByAndDirection()=='isAdBlockUser_DESC', 'list-sort-asc': orderByAndDirection()=='isAdBlockUser_ASC' }">Ad Block User Condition</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'isBotRequest') }, css: { 'list-sort-desc': orderByAndDirection()=='isBotRequest_DESC', 'list-sort-asc': orderByAndDirection()=='isBotRequest_ASC' }">Is Bot Request Condition</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'has5ListItemsOrMore') }, css: { 'list-sort-desc': orderByAndDirection()=='has5ListItemsOrMore_DESC', 'list-sort-asc': orderByAndDirection()=='has5ListItemsOrMore_ASC' }">List User Condition</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'isPushNotificationSubscribed') }, css: { 'list-sort-desc': orderByAndDirection()=='isPushNotificationSubscribed_DESC', 'list-sort-asc': orderByAndDirection()=='isPushNotificationSubscribed_ASC' }">Push Notifications Condition</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'isHighlyEngaged') }, css: { 'list-sort-desc': orderByAndDirection()=='isHighlyEngaged_DESC', 'list-sort-asc': orderByAndDirection()=='isHighlyEngaged_ASC' }">High Engagement Condition</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'isAvailable') }, css: { 'list-sort-desc': orderByAndDirection()=='isAvailable_DESC', 'list-sort-asc': orderByAndDirection()=='isAvailable_ASC' }">Is Available For Use</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateCreated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateCreated_DESC', 'list-sort-asc': orderByAndDirection()=='dateCreated_ASC' }">Date Created</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateUpdated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateUpdated_DESC', 'list-sort-asc': orderByAndDirection()=='dateUpdated_ASC' }">Date Updated</span></th>
                            </tr>
                        </thead>

                        <tbody data-bind="foreach: promotions">
                            <tr class="cursor">
                                <td data-bind=" if: id, event: { click: $parent.onClickViewPromotion }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: id"></span></a></td>
                                <td data-bind=" if: name, event: { click: $parent.onClickViewPromotion }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: name"></span></a></td>
                                <td data-bind=" event: { click: $parent.onClickViewPromotion }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: geo"></span></a></td>
                                <td data-bind=" if: isLoginUser, event: { click: $parent.onClickViewPromotion }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: isLoginUser"></span></a></td>
                                <td data-bind=" if: isPremiumUser, event: { click: $parent.onClickViewPromotion }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: isPremiumUser"></span></a></td>
                                <td data-bind=" if: isAdBlockUser, event: { click: $parent.onClickViewPromotion }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: isAdBlockUser"></span></a></td>
                                <td data-bind=" if: isBotRequest, event: { click: $parent.onClickViewPromotion }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: isBotRequest"></span></a></td>
                                <td data-bind=" if: has5ListItemsOrMore, event: { click: $parent.onClickViewPromotion }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: has5ListItemsOrMore"></span></a></td>
                                <td data-bind=" if: isPushNotificationSubscribed, event: { click: $parent.onClickViewPromotion }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: isPushNotificationSubscribed"></span></a></td>
                                <td data-bind=" if: isHighlyEngaged, event: { click: $parent.onClickViewPromotion }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: isHighlyEngaged"></span></a></td>
                                <td data-bind=" if: isAvailable,  event: { click: $parent.onClickViewPromotion } "><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: isAvailable"></span></a></td>
                                <td data-bind=" if: dateCreated, event: { click: $parent.onClickViewPromotion }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: dateCreated.substring(0, 10)"></span></a></td>
                                <td data-bind=" if: dateUpdated, event: { click: $parent.onClickViewPromotion }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: dateUpdated.substring(0, 10)"></span></a></td>
                            </tr>
                        </tbody>
                </table>


                <div class="w-form w-form-large" data-bind="visible: viewType() == 'config'" style="margin: 0 auto;">
                    <div class="w-form-body">
                        <div class="form-body full-width">
                            <table class="list-action" data-bind="visible: zones().length > 0">
                                <thead>
                                    <tr>
                                        <th><span>Zone</span></th>
                                        <th><span>Opportunity</span></th>
                                        <th><span>Competing</span></th>
                                    </tr>
                                </thead>
                                <tbody data-bind="foreach: zones">
                                    <tr>
                                        <td><span data-bind="text: name"></span></td>
                                        <td><span data-bind="text: opportunities"></span></td>
                                        <td><span data-bind="text: opportuniyTarget"></span></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="w-form-body">
                        <div class="form-body full-width">
                            <table class="list-action" data-bind="visible: configs().length > 0">
                                <thead>
                                    <tr>
                                        <th><span>Active</span></th>
                                        <th><span>Promotion</span></th>
                                        <th><span>Zone</span></th>
                                        <th><span>Opportunity Target</span></th>
                                        <th><span>Sentinel Tracking</span></th>
                                        <th><span>Delete</span></th>
                                    </tr>
                                </thead>
                                <tbody data-bind="foreach: configs">
                                    <tr>
                                        <td><input type="checkbox" data-bind="checked: isActive, attr:{id: 'is-active-' + $index()}"/>
                                        <label class="form-label icon i-check" data-bind="attr:{for: 'is-active-' + $index()}"></label></td>
                                        <td><div data-bind="template: { name: 'filterDropdown-template', data: $data.promotion.getTemplateViewModel() }"></div></td>
                                        <td><div data-bind="template: { name: 'filterDropdown-template', data: $data.zone.getTemplateViewModel() }"></div></td>
                                        <td><input type="number" class="input-text" data-bind="value: opportunityTarget" /></td>
                                        <td><input type="checkbox" data-bind="checked: isSentinelTrackingEnabled, attr:{id: 'is-sentinel-tracking-' + $index()}"/>
                                        <label class="form-label icon i-check" data-bind="attr:{for: 'is-sentinel-tracking-' + $index()}"></label></td>
                                        <td data-bind="event:{ click: $parent.onClickDeleteConfig }"><span class="btn border only-icon border highlight icon i-delete"></span></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="form-footer">
                        <button type="button" data-bind="event: { click: onClickCancelConfig }" class="btn btn">Cancel</button>
                        <button type="button" data-bind="event: { click: onClickSaveConfig }" class="btn highlight">Save</button>
                    </div>
                </div>
            </div>
         `;
    }

    protected buildViewModel(): any {
        let self = this
        return {
            viewType: ko.observable('list'),
            promotions: ko.observableArray([]),
            allPromotions: ko.observableArray([]),
            promotionsAvailableToUse: ko.observableArray([]),
            configs: ko.observableArray([]),
            originalConfigs: ko.observableArray([]),
            orderBy: ko.observable("name"),
            orderByDirection: ko.observable("ASC"),
            orderByAndDirection: ko.observable("name_ASC"),
            zones: ko.observableArray([]),
            permissions: ko.observableArray(self.initPermissions(['config_promotion'])),
            onClickReorder: (value, data, event) => {
                self.onClickReorder(value, data, event);
            },
            onClickAddPromotion: (data, event) => {
                self.onClickAddPromotion()
            },
            onClickViewPromotion: (data, event) => {
                self.onClickViewPromotion(data.id, event);
            },
            onClickAddConfig: (data, event) => {
                self.onClickAddConfig();
            },
            onClickSaveConfig: (data, event) => {
                self.onClickSaveConfig();
            },
            onClickCancelConfig: (data, event) => {
                self.onClickCancelConfig();
            },
            onClickDeleteConfig: (data, event) => {
                self.onClickDeleteConfig(data);
            }
        }
    }

    protected initPartial(): void {

        this.resultInfos = new resultsInfo_template('resultInfo', this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
    }


    protected getTemplateName(): string {

        return "config_promotion_template";
    }

    public getViewModelForRequest() {

        return {
            orderBy: this.getTemplateViewModel().orderBy,
            orderByDirection: this.getTemplateViewModel().orderByDirection,
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
            pagination: this.getTemplateViewModel().pagination,
            filters: {
                keywords: this.getTemplateViewModel().filter.filterKeyword,
            },
        }
    }

    public getConfigs() {

        let data = [];
        let configs = this.getTemplateViewModel().configs();

        for (let i = 0; i < configs.length; i++) {

            data.push({
                idPromotion: configs[i].promotion.getTemplateViewModel().selectedOption,
                idZone: configs[i].zone.getTemplateViewModel().selectedOption,
                isActive: configs[i].isActive,
                opportunityTarget: configs[i].opportunityTarget,
                isSentinelTrackingEnabled: configs[i].isSentinelTrackingEnabled
            })
        }

       return data;
    }

    public setZones(zones) {

        this.getTemplateViewModel().zones(zones);
    }

    public setPermissions(permissions) {

        this.getTemplateViewModel().permissions(permissions);
    }

    public setPromotions(promotions) {

        this.getTemplateViewModel().promotions(promotions);
    }

    public setAllPromotions(promotions) {

        this.getTemplateViewModel().allPromotions(promotions);
    }

    public setPromotionsAvailableToUse(promotions) {

        this.getTemplateViewModel().promotionsAvailableToUse(promotions);
    }

    public onClickShowPopUp(data) {

        this.getTemplateViewModel().configToDelete(data);
        this.togglePopUp();
    }

    public onClickHidePopUp() {

        this.getTemplateViewModel().configToDelete(null);
        this.togglePopUp();
    }

    public togglePopUp() {

        document.getElementById("delete-dialog").classList.toggle("is-visible");
    }

    public setConfigs(configs) {

        let allPromotions = this.getTemplateViewModel().allPromotions();
        let promotionsAvailableToUse = this.getTemplateViewModel().promotionsAvailableToUse();
        let zones = this.getTemplateViewModel().zones();

        for (let i = 0; i < configs.length; i++) {

            //if configs[i].promotion.id is not in promotionsAvailableToUse
            let found = promotionsAvailableToUse.find(function (promotion) {return promotion.id == configs[i].promotion.id})

            let promotionFilter = new filterDropdown_template("filterPromotion_"+i, this.getTemplateViewModel(), this.caller);
            promotionFilter.setLabel('Promotion');
            promotionFilter.setOptions(found ? promotionsAvailableToUse : allPromotions);
            promotionFilter.setSelectedOption(configs[i].promotion.id);

            let zoneFilter = new filterDropdown_template("filterZone_"+i, this.getTemplateViewModel(), this.caller);
            zoneFilter.setLabel('Zone');
            zoneFilter.setOptions(zones);
            zoneFilter.setSelectedOption(configs[i].zone.id);

            //set the filters
            configs[i].promotion = promotionFilter;
            configs[i].zone = zoneFilter;
        }

        //set the original configs
        this.getTemplateViewModel().originalConfigs([]);
        this.getTemplateViewModel().originalConfigs(configs);

        //set the configs
        this.getTemplateViewModel().configs([]);
        this.getTemplateViewModel().configs([...configs]);
    }

    protected onClickReorder(value, data, event): any {

        data.orderBy(value);
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.listReorder();
    }

    protected onClickViewPromotion(id, event) {

        this.caller.onClickViewPromotion(id);
    }

    protected onClickAddPromotion(): any {

        this.caller.onClickAddPromotion()
    }

    protected onClickAddConfig(): any {

        let promotionsAvailableToUse = this.getTemplateViewModel().promotionsAvailableToUse();
        let zones = this.getTemplateViewModel().zones();
        let configs = this.getTemplateViewModel().configs();
        let index  = configs.length;

        let promotionFilter = new filterDropdown_template("filterPromotion_"+index, this.getTemplateViewModel(), this.caller);
        promotionFilter.setLabel('Promotion');
        promotionFilter.setOptions(promotionsAvailableToUse);

        let zoneFilter = new filterDropdown_template("filterZone_"+index, this.getTemplateViewModel(), this.caller);
        zoneFilter.setLabel('Zone');
        zoneFilter.setOptions(zones);

        let config = {
            id : null,
            isActive: true,
            promotion : promotionFilter,
            zone : zoneFilter,
            opportunityTarget : '',
            isSentinelTrackingEnabled: true,
        }

        configs.push(config);
        this.getTemplateViewModel().configs([]);
        this.getTemplateViewModel().configs(configs);
    }

    protected onClickDeleteConfig(config) {

        let configs = this.getTemplateViewModel().configs();
        configs.splice(configs.indexOf(config), 1);
        this.getTemplateViewModel().configs([]);
        this.getTemplateViewModel().configs(configs);
    }

    protected onClickSaveConfig() {

        this.caller.onClickSaveConfig();
    }

    protected onClickCancelConfig() {

        let configs = this.getTemplateViewModel().originalConfigs();
        this.getTemplateViewModel().configs([]);
        this.getTemplateViewModel().configs([...configs]);
    }

    public setResultInfo(nbResults, nbPages, execTime ) {

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/configPromotionsList_template.ts